import React, { Component } from 'react'
import { connect } from 'react-redux'
import { IconButton, Typography } from '@material-ui/core'
import IconBack from '@material-ui/icons/ArrowBack'
import { injectIntl } from 'react-intl'
import {
  translationsMonitoringAlertsFetchFormData,
  translationsMonitoringAlertsClearStateForm,
  translationsMonitoringAlertsChange,
} from 'reducers/translations/monitoringAlerts/reducer'
import { fetchProfile } from 'reducers/profile/reducer'
import withPromise from 'helpers/withPromise'
import messages from './translate'
import MonitoringAlertsForm from './MonitoringAlertsForm'

class MonitoringAlertsItem extends Component {
  constructor(props) {
    super(props)
    this.state = {
      redirect: false,
    }
  }

  componentDidMount() {
    const {
      translationsMonitoringAlertsFetchFormData,
      match: {
        params: { id },
      },
    } = this.props

    translationsMonitoringAlertsFetchFormData({
      entityId: id,
    })
  }

  shouldComponentUpdate(nextProps, nextState) {
    const {
      history: { goBack },
    } = this.props

    if (nextState.redirect) {
      goBack()

      return false
    }

    return true
  }

  componentWillUnmount() {
    const { translationsMonitoringAlertsClearStateForm } = this.props

    translationsMonitoringAlertsClearStateForm()
  }

  onSubmit = values => {
    const {
      fetchProfile,
      translationsMonitoringAlertsChange,
      match: {
        params: { id },
      },
    } = this.props
    const formatValues = { translations: [] }

    Object.keys(values).forEach(key => {
      const value = values[key]
      formatValues.translations.push({
        ...value,
        locale: key,
      })
    })

    return withPromise(translationsMonitoringAlertsChange, {
      entityId: id,
      values: formatValues,
    })
      .then(errors =>
        errors ? Promise.resolve(errors) : this.setState({ redirect: true }),
      )
      .then(() => {
        fetchProfile()
      })
  }

  render() {
    const {
      formData,
      intl: { formatMessage },
      history: { goBack },
    } = this.props

    return (
      <div className="container-fluid no-breadcrumb">
        <Typography variant="h5" className="headline">
          <IconButton size="medium" className="btn-back" onClick={goBack}>
            <IconBack fontSize="small" />
          </IconButton>
          {formatMessage(messages.monitoringAlertsTranslation)}
        </Typography>
        <MonitoringAlertsForm
          formData={formData}
          onSubmit={this.onSubmit}
          {...this.props}
        />
      </div>
    )
  }
}

export default connect(
  state => ({
    formData: state.getIn(['monitoringAlertsTranslations', 'formData']).toJS(),
  }),
  {
    translationsMonitoringAlertsFetchFormData,
    translationsMonitoringAlertsClearStateForm,
    translationsMonitoringAlertsChange,
    fetchProfile,
  },
)(injectIntl(MonitoringAlertsItem))
